import cn from 'classnames'
import React, { useState } from 'react'
import { IContentItemFragment, IContentListItemFragment, IEnum_Content_Contenttype } from 'src/graphql/generated/hooks'

import { ContentListItem } from './ContentListItem/ContentListItem'

export interface ContentlistProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  items: (IContentItemFragment | IContentListItemFragment | any)[]
  showDocumentType?: boolean
  className?: string
  contentType?: IEnum_Content_Contenttype
}

export const ContentList: React.FC<ContentlistProps> = ({
  items,
  showDocumentType = false,
  className = '',
  contentType,
}) => {
  const [openTooltipCardId, setOpenTooltipCardId] = useState<string | null>(null)
  //const [subjectMatterPopup, setSubjectMatterPopup] = useState(0)

  // const carouselSlideChange = (index: number) => {
  //   const randomNum = Math.floor(Math.random() * 90000) + 10000 + index
  //   setSubjectMatterPopup(randomNum)
  // }

  return (
    <div className={cn(className, 'bg-white', 'border-y', 'border-zinc-300')}>
      <ul className="divide-y divide-zinc-300">
        {items.map((item, index) => {
          //setSubjectMatterPopup(item.id)
          return (
            <li key={index}>
              <ContentListItem
                item={item}
                openTooltipCardId={openTooltipCardId}
                setOpenTooltipCardId={setOpenTooltipCardId}
                subjectMatterPopup={1}
                showDocumentType={showDocumentType}
                contentType={contentType}
              />
            </li>
          )
        })}
      </ul>
    </div>
  )
}
